import { getObjectFromJSONString } from "../../../components/Factory/Molecules/Common/Navigations/AddEntity/M_ManageEntityForm.helper";
import { httpPost, httpPut } from "../../apis/apis";
//Add
export const CreateDestinationVertex = async (payload, params = {}) => {
  // eslint-disable-next-line no-extra-boolean-cast
  let url = !!getObjectFromJSONString(
    params,
    ".entity.parameters.externalInsiderList"
  )
    ? "/Compliance/insiderList/insert"
    : "/CRMData/insert";
  if ("undefined" in payload) {
    delete payload["undefined"];
  }

  if (payload && payload.properties) {
    delete payload.properties["undefined"];
  }
  const res = await httpPost(url, payload);
  return res;
};
//Edit
export const EditDestinationVertex = (payload) => {
  httpPost(`/CRMData/edit`, payload);
};
//addEdge
export const AddEdge = async (payload) => {
  const res = await httpPut(`/CRMData/addEdge`, payload);
  return res;
};
